import { render, staticRenderFns } from "./FooterMenusAbout.vue?vue&type=template&id=4fe9c2f2"
import script from "./FooterMenusAbout.vue?vue&type=script&lang=js"
export * from "./FooterMenusAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports